const AccountService = {
  subtypes: {
    superadmin: 'sadmin',
    admin: 'admin',
    operator: 'operator',
    infra: 'infra',
    developer: 'developer'
  },
  defaultRights: {
    landlord: false,
    accounts: true,
    accountsEdit: true
  },
  typesForDropdown: function (withSuperadmin = false) {
    let types = [
      { value: 'admin', text: 'Admin' },
      { value: 'developer', text: 'Developer' },
      { value: 'operator', text: 'Operator' },
      { value: 'infra', text: 'Infra' }
    ]
    if (withSuperadmin) types = [{ value: 'sadmin', text: 'Superadmin' }].concat(types)
    return types
  },
  getRights: function (subtype) {
    let rights = {}
    for (let key in this.defaultRights) { rights[key] = this.defaultRights[key] }
    switch (subtype) {
      case this.subtypes.superadmin:
        rights.landlord = true
        break
    }
    return rights
  }
}
export default AccountService